import { config } from "../../../../frontend.config";

export const localization: LocalizationConfig = {
    available: config.locales,
    locales: {
        en: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        zh: {
            fonts: {
                primaryFont: "clash-royale-cn",
                secondaryFont: "proximanova_semibold",
            },
        },
        "zh-hans": {
            fonts: {
                primaryFont: "clash-royale-cn",
                secondaryFont: "proximanova_semibold",
            },
        },
        fr: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        de: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        id: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        it: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        ja: {
            fonts: {
                primaryFont: `"ヒラギノ角ゴ Pro W3","Hiragino Kaku Gothic Pro", "ＭＳ ゴシック","MS Gothic", Arial, sans-serif`,
                secondaryFont: "Arial, sans-serif",
                titleBoldValue: "bold",
            },
        },
        ko: {
            fonts: {
                primaryFont: "SC COC Display Bold",
                secondaryFont: "proximanova_semibold",
                titleBoldValue: "bold",
            },
        },
        pl: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        pt: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        ru: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        es: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
        th: {
            fonts: {
                primaryFont: "supercell-magicregular",
                secondaryFont: "proximanova_semibold",
            },
        },
    },
};
